import { render } from "./Collection_Bulk_Upload.vue?vue&type=template&id=3b76bd9a&scoped=true"
import script from "./Collection_Bulk_Upload.vue?vue&type=script&lang=js"
export * from "./Collection_Bulk_Upload.vue?vue&type=script&lang=js"

import "./Collection_Bulk_Upload.vue?vue&type=style&index=0&id=3b76bd9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b76bd9a"]])

export default __exports__